import axios from "axios";
import { storageAvailable } from "../providers/LocalStorageProvider";
import SecureStorage from "../utils/secureStorage";

const httpService = axios.create({
  baseURL: process.env.REACT_APP_UMD_BACK_END_DOMAIN
    ? process.env.REACT_APP_UMD_BACK_END_DOMAIN
    : "/umd-service/api",
});

httpService.interceptors.request.use(
  (config) => {
    try {
      try {
        const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
        if (tz) {
          config.headers = config.headers || {};
          config.headers["X-User-Timezone"] = tz;
        }
      } catch {}

      const credentials = SecureStorage.getAuthCredentials();
      if (credentials && storageAvailable("localStorage")) {
        if (credentials.username && credentials.password) {
          const auth = btoa(`${credentials.username}:${credentials.password}`);
          config.headers = config.headers || {};
          const hasAuthHeader = Object.keys(config.headers).some(
            (key) => key.toLowerCase() === "authorization"
          );
          if (!hasAuthHeader) {
            config.headers["Authorization"] = `Basic ${auth}`;
          }
        }

        const authData = SecureStorage.getAuthServiceData();

        if (authData && authData.customer_top_plan) {
          config.headers = config.headers || {};
          config.headers["X-Client-Plan-Tier"] = authData.customer_top_plan;
          config.headers["X-Client-Subscription-Status"] =
            authData.hasValidSubscription ? "active" : "inactive";

          config.headers["X-Client-Validation-Timestamp"] =
            new Date().toISOString();
        }
      }
    } catch (error: any) {
      console.warn(
        "Failed to add authentication/permission headers:",
        error.message
      );
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

httpService.interceptors.response.use(undefined, (error) => {
  const url = error?.config?.url;

  if (
    url?.includes("/login") ||
    url?.includes("call-bot") ||
    url?.includes("/esignature/sign/") ||
    url?.includes("/lmc/gaming/")
  ) {
    return Promise.reject(error);
  }

  if (
    error.response?.status === 401 &&
    (error?.response?.data?.code === "RSSEKO001" ||
      error?.response?.data?.code === "RSSUKO001")
  ) {
    if (SecureStorage.isImpersonationTab()) {
      SecureStorage.clearImpersonationSession();
      window.location.href = "/impersonation-ended";
      return new Promise(() => {});
    }
    if (SecureStorage.isCustomerTab()) {
      if (SecureStorage.hasCustomerSession()) {
        SecureStorage.invalidateCustomerSession();
        window.location.reload();
        return new Promise(() => {});
      }
      return Promise.reject(error);
    }
    window.location.href = "/logout";
    return new Promise(() => {});
  }

  return Promise.reject(error);
});

const HttpService = {
  get: httpService.get,
  post: httpService.post,
  put: httpService.put,
  patch: httpService.patch,
  delete: httpService.delete,
};

export default HttpService;
